import { Sessions } from '@rhino-project/ui-heroui';
import { prefetchSessions } from '@rhino-project/core/queries';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/$owner/account/settings/sessions'
)({
  // Prefetch the session list so the page renders warm with no spinner flash.
  loader: ({ context: { rhino } }) => prefetchSessions(rhino),
  component: Sessions
});
